import React from 'react';
import classNames from 'classnames';
import styles from './Button.module.scss';
import LoadingIcon from '../../../assets/icons/loading.svg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'link';
  size?: 'small' | 'medium' | 'large';
  loading?: boolean;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'medium',
  loading = false,
  icon,
  iconPosition = 'right',
  fullWidth = false,
  disabled,
  className,
  ...props
}) => {
  return (
    <button
      className={classNames(
        styles.button,
        styles[variant],
        styles[size],
        {
          [styles.fullWidth]: fullWidth,
          [styles.loading]: loading,
          [styles.disabled]: disabled || loading,
        },
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      {icon && iconPosition === 'left' && !loading && <span className={styles.icon}>{icon}</span>}
      {children}
      {loading && <img src={LoadingIcon} alt="Loading" className={styles.loadingIcon} />}
      {icon && iconPosition === 'right' && !loading && <span className={styles.icon}>{icon}</span>}
    </button>
  );
};

export default Button;

